import { Fields as FavoriteFields } from 'defs/ga/fields/favorite';
import GlobalFields from 'defs/ga/fields/global';
import { Generic as ProductFields } from 'defs/ga/fields/product';

export const trackFavoriteAuto = ({ favorite, coachCardType, coachProdNm, coachProdId }) => ({
	[GlobalFields.Event]: 'buttonClick',
	[FavoriteFields.ButtonText]: favorite ? 'set favourite' : 'delete favourite',
	[FavoriteFields.Type]: coachCardType,
	[ProductFields.ProductId]: coachProdId,
	[ProductFields.ProductName]: coachProdNm,
});
